export default __webpack_public_path__ + "static/media/lung_plot_female.f4444b96.png";